module.exports = __webpack_public_path__ + "img/FGr_WP_C.022ceca6.svg";